<ion-header class="background-lightmimbo">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Can Paws Eat It?</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <ion-grid>
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-searchbar *ngIf="!isLoading" autocomplete="on" autocorrect="on" (ionInput)="onFilterChanged(searchBar)"
          #searchBar></ion-searchbar>
        <div class="ion-text-center ion-padding" *ngIf="!isLoading && filteredFoodList.length<=0">
          <ion-text color="darkmimbo">No Results Found.</ion-text>
        </div>
        <ion-list approxItemHeight="48" *ngIf="!isLoading && filteredFoodList.length>0">
          <ion-item *ngFor="let foodItem of filteredFoodList" color="lightmimbo"
            [routerLink]="['/edible/details/',foodItem.name]" detail>
            <ion-label>{{foodItem.name}}</ion-label>
          </ion-item>
        </ion-list>
      </ion-col></ion-row>
  </ion-grid>
</ion-content>